import * as React from 'react'
import { IRiderActivityLocationObject } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import LocationActivityListItem from './LocationActivityListItem'

interface ILocationListProps {
  locationActivity: IRiderActivityLocationObject[]
}

class LocationActivityList extends React.Component<ILocationListProps> {
  constructor(props: ILocationListProps) {
    super(props)
    this.state = {
      hover: false
    }
  }

  public render() {
    return (
      <div className='flex'>
        <div style={{ flex: 2 }}>
          <div className='flex'>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.nameLabel}</span>
            </div>
            <div className='col-4'>
              <span className='h5 font-grey2'>{UIMessages.common.address}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.note}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.createdAt}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.updatedAt}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.deletedAt}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.by}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.before}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.after}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.field}</span>
            </div>
          </div>
          <div className='bt-light-grey4 mt1'>&nbsp;</div>
          {!!this.props.locationActivity.length ? (
            this.props.locationActivity.map((item, i) => (
              <LocationActivityListItem key={`tmli-${i}`} locationActivity={item} />
            ))
          ) : (
            <i className='fs-16 font-light-grey text-center'>
              <p>{UIMessages.rider.location.noLocation}</p>
            </i>
          )}
        </div>
      </div>
    )
  }
}

export default LocationActivityList



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/location/LocationActivityList.tsx